import React from 'react'
import Arrow from 'svg/caret-down.svg'
export type SectionProps = {
  children?: React.ReactElement<React.ComponentProps<any>, any>
  currentSection: string
  name?: string
  onToggle: (...args: Array<any>) => any
  section: string
  title?: string
}

const Component = (
  props: SectionProps
): React.ReactElement<React.ComponentProps<any>, any> | null => {
  const { children, currentSection, name, onToggle, section, title } = props
  const isOpen = currentSection === section
  return (
    <>
      <section data-section={name}>
        <div
          data-type='header'
          onClick={() => {
            onToggle(section)
          }}
          onKeyDown={(ev) => {
            onToggle(section)
          }}
          role='button'
          tabIndex='0'
          title={isOpen ? 'Collapse' : 'Expand'}
        >
          <h2 data-type='section-title'>{title}</h2>

          <Arrow
            data-type='arrow'
            {...(isOpen
              ? {
                  open: 'open',
                }
              : {})}
          />
        </div>

        <div
          data-style='toggle-element'
          {...(isOpen
            ? {
                'data-visible': 'true',
              }
            : {})}
        >
          <fieldset data-type='form-section'>{children}</fieldset>
        </div>
      </section>
    </>
  )
}

export default Component